import styled from "styled-components";
import {
  ACCENT_PRIMARY_LIGHTEST,
  BRAND,
  GRAY,
  GRAY_DARK,
  GRAY_LIGHT,
  TEXT_PRIMARY,
  WHITE
} from "@streeteasy/design-system/colors";
import Button from "@streeteasy/design-system/deprecated/actions/button";
import { Fieldset } from "@streeteasy/design-system/form";
import { Caps } from "@streeteasy/design-system/typography";

import SEModal from "src/shared/components/SEModal";

const FieldsetWrap = styled(Fieldset)`
  display: flex;
  flex-wrap: wrap;

  @media screen and (max-width: 660px) {
    max-height: calc(100vh - 385px);
    overflow: auto;
  }
`;

const PhotoWrap = styled.div`
  background-image: ${props => `url(${props.photoSrc})`};
  background-position: center;
  background-size: cover;
  height: 240px;
  position: relative;
  @media screen and (max-width: 660px) {
    height: 140px;
  }
`;

const Address = styled(Caps)`
  background-color: ${GRAY_DARK};
  border-radius: 2px;
  bottom: 0;
  color: ${WHITE};
  padding: 3px 7px;
  position: absolute;
  z-index: 13;
`;

const ModalContent = styled.div`
  flex: 1 0 auto;
  padding: 32px;
  p {
    font-size: 28px;
    font-weight: 100;
    margin: 0 0 15px 0;
  }
  @media screen and (max-width: 660px) {
    padding: 24px 20px;
  }
`;

const ModalContainer = styled.div`
  background-color: ${WHITE};
  display: flex;
  flex-direction: column;
  height: fit-content;
  width: 619px;
  @media screen and (max-width: 660px) {
    max-height: calc(100vh - 52px);
    height: calc(100vh - 52px);
  }
`;

const ModalFooter = styled.div`
  background-color: ${WHITE};
  border-top: 1px solid ${GRAY_LIGHT};
  flex: 0 0 auto;
  padding: 32px;
  @media screen and (max-width: 660px) {
    padding: 20px;
  }
`;

const ButtonsWrap = styled.div`
  display: flex;
  justify-content: space-between;
  div:first-of-type {
    margin-right: 20px;
  }
`;

const ModalButton = styled(Button)`
  max-width: 257.5px;
  min-width: auto;
  width: 100%;

  @media screen and (max-width: 660px) {
    ${({ leftSpacer }) =>
      leftSpacer ? `margin-left: 5px;` : `margin-right: 5px`}
  }
`;

const ModalWrap = styled(SEModal)`
  @media screen and (max-width: 660px) {
    top: 52px !important;
    transform: translate(-50%) !important;
    width: 100%;

    > div {
      width: 100%;
    }
  }
`;

const Pill = styled.label`
  display: flex;
  margin: 0;
  margin-bottom: 8px;
  margin-right: 8px;

  span {
    background: ${WHITE};
    border: 1px solid ${GRAY};
    border-radius: 100px;
    box-sizing: border-box;
    color: ${TEXT_PRIMARY};
    cursor: pointer;
    font-size: 14px;
    height: 28px;
    line-height: 16px;
    padding: 5px 20px;
    position: relative;
  }

  span:hover {
    border: 1px solid ${BRAND};
  }

  input {
    border: none;
    clip: rect(0, 0, 0, 0);
    marign: 0;
    position: absolute;
  }

  &:focus-within {
    & > span::after {
      border: 1px solid ${TEXT_PRIMARY};
      border-radius: 100px;
      content: "";
      height: 34px;
      left: -4px;
      position: absolute;
      top: -4px;
      width: calc(100% + 8px);
    }
  }

  input:checked + span:hover {
    border: 1px solid ${GRAY};
  }

  input:checked + span {
    background-color: ${ACCENT_PRIMARY_LIGHTEST};
  }
`;

export {
  Address,
  ButtonsWrap,
  FieldsetWrap,
  ModalButton,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalWrap,
  PhotoWrap,
  Pill
};
